/**
 * 车辆风险评分相关请求
 */
import request from "@/utils/request";

export const carRiskListRequestPath = '/api/v2/carRisk/list';

export interface CarRiskScoreRange {
  /** 区间下界（开区间，不包含） */
  start: number;
  /** 区间上界（闭区间，包含） */
  end: number;
}

export interface CarRiskListRequestParams {
  page?: number;
  limit?: number;
  export?: boolean;
  /** 车队名称 */
  fleetName?: string;
  /** 业务模式：中富模式/保险模式 */
  mode?: string;
  /** 车辆名称（车牌号） */
  plateNumber?: string;
  /** 车辆评级：高危/中危 */
  riskLevel?: string;
  /** 报告日期（单日查询） */
  reportDate?: string;
  /** 评分开始日期 */
  scoreStartDate?: string;
  /** 评分结束日期 */
  scoreEndDate?: string;
  /** 车辆评分区间 */
  scoreRanges?: CarRiskScoreRange[];
  [property: string]: any;
}

export interface CarRiskDto {
  /** 车辆ID */
  carId?: number | null;
  /** 车辆类型编码（原始值，来自car表） */
  carType?: number | null;
  /** 车辆类型（中文描述） */
  carTypeDesc?: string | null;
  /** 记录创建时间 */
  createdAt?: string | null;
  /** 设备预警评分 */
  deviceAlarmScore?: number | null;
  /** 驾驶习惯评分 */
  driverHabitScore?: number | null;
  /** 车队名称 */
  fleetName?: string | null;
  /** 主键ID */
  id?: number | null;
  /** 线路安全评分 */
  lineSafeScore?: number | null;
  /** 精神状态评分 */
  mentalStateScore?: number | null;
  /** 业务模式 */
  mode?: string | null;
  /** 车牌号（车辆名称） */
  plateNumber?: string | null;
  /** 风险级别：高危/中危 */
  riskLevel?: string | null;
  /** 综合安全评分 */
  safeScore?: number | null;
  /** 日期（评分开始~结束拼接） */
  scoreDateRange?: string | null;
  /** 评分结束日期 */
  scoreEndDate?: string | null;
  /** 评分开始日期 */
  scoreStartDate?: string | null;
  /** 车辆型号 */
  vehicleModel?: string | null;
  /** 工作强度评分 */
  workIntensityScore?: number | null;
  [property: string]: any;
}

// 获取车辆风险评分列表/导出
export const carRiskListRequest = (params: CarRiskListRequestParams) => {
  const { scoreRanges, ...rest } = params;
  const newParams: Record<string, any> = { ...rest };
  if (scoreRanges && scoreRanges.length > 0) {
    scoreRanges.forEach((range, index) => {
      newParams[`scoreRanges[${index}].start`] = range.start;
      newParams[`scoreRanges[${index}].end`] = range.end;
    });
  }
  return request.get(carRiskListRequestPath, {
    params: newParams
  })
}
